import PagedElements from '@/models/paged/pagedelements';
import ItemRankLinkListViewModel from '@/models/view/itemranklinklistviewmodel';

export default class PagedItemRankLinks extends PagedElements<ItemRankLinkListViewModel> {
    constructor(init?: Partial<PagedItemRankLinks>) {
        super(init);
    }
}
